<template>
  <el-form ref="form" :model="loginForm" label-width="0">
    <h3 class="login-title">账号登录</h3>
    <el-form-item prop="username">
      <el-input v-model="loginForm.username" placeholder="请输入您的账号">
      </el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input v-model="loginForm.password" placeholder="请输入您的密码">
      </el-input>
    </el-form-item>
    <el-form-item style="margin-top: -10px">
      <el-checkbox v-model="checkLoginStatus">7天内自动登录</el-checkbox>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" style="width: 100%" @click="handleLogin"
        >登录</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
      },
      username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
      password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      checkLoginStatus: false,
    }
  },
  methods: {
    handleLogin() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在登录中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          this.$store
            .dispatch('user/userLogin', {
              ...this.loginForm,
              checkLoginStatus: this.checkLoginStatus,
            })
            .then(() => {
              loading.close()
              this.loginForm = {}
            })
            .catch(() => {
              loading.close()
            })
        }
      })
    },
  },
}
</script>

<style scoped>
.login-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}
.forgot {
  float: right;
}
</style>
